export default "/images/framework/ScoreTBG.f7d3d328.svg?f7d3d328";